import { useSetRecoilState } from 'recoil';
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { toastApiError } from '../../utils/ApiError';
import { selectedPageAtom } from '../../atoms/Page';
import { Institution } from '../../interfaces/Institution';
import { Department } from '../../interfaces/Department';
import { DepartmentSection } from '../../interfaces/DepartmentSection';
import { getInstitutions } from '../../services/Institution';
import { getDepartments } from '../../services/Department';
import { getDepartmentSections } from '../../services/DepartmentSection';
import { PageType } from '../../interfaces/Page';
import Waiting from '../Waiting';
import { sharedStyles } from '../../utils/Style';
import UserTable from './UserTable';

const UserPage = () => {
  const setSelectedPage = useSetRecoilState(selectedPageAtom);

  const [loadingInstitutions, setLoadingInstitutions] = useState(false);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [loadingSections, setLoadingSections] = useState(false);
  const [institutions, setInstitutions] = useState<Institution[]>([]);
  const [departments, setDepartments] = useState<Department[]>([]);
  const [departmentSections, setDepartmentSections] = useState<
    DepartmentSection[]
  >([]);

  const refreshState = () => {
    setLoadingInstitutions(true);
    getInstitutions()
      .then((fetchedInstitutions) => setInstitutions(fetchedInstitutions))
      .catch((err) => toastApiError(err))
      .finally(() => setLoadingInstitutions(false));

    setLoadingDepartments(true);
    getDepartments()
      .then((fetchedDepartments) => setDepartments(fetchedDepartments))
      .catch((err) => toastApiError(err))
      .finally(() => setLoadingDepartments(false));

    setLoadingSections(true);
    getDepartmentSections()
      .then((sections) => setDepartmentSections(sections))
      .catch((err) => toastApiError(err))
      .finally(() => setLoadingSections(false));
  };

  useEffect(() => {
    setSelectedPage(PageType.USER);

    refreshState();
  }, []);

  const loading = loadingInstitutions || loadingDepartments || loadingSections;

  return (
    <Box component='div'>
      <Waiting open={loading} />
      <Box component='div' sx={sharedStyles.pageBody}>
        <UserTable
          institutions={institutions}
          departments={departments}
          departmentSections={departmentSections}
        />
      </Box>
    </Box>
  );
};

export default UserPage;
